import { FormProvider } from '../hooks/useFormState';
import { I18nProvider } from '../i18n';
import { RoleSwitcher } from './layout/RoleSwitcher';
import { AppRoutes } from './routes';
import type { AppVariantConfig } from './variant';

interface AppRootProps {
  config: AppVariantConfig;
}

export function AppRoot({ config }: AppRootProps) {
  const VariantApp = config.AppContent;

  return (
    <I18nProvider
      locale={config.locale}
      messages={config.messages}
      fallbackMessages={config.fallbackMessages}
    >
      {VariantApp ? (
        <VariantApp />
      ) : (
        <FormProvider>
          <RoleSwitcher />
          <AppRoutes />
        </FormProvider>
      )}
    </I18nProvider>
  );
}
